// extracted by mini-css-extract-plugin
module.exports = {"contents":"DQ","sectionHeading":"EQ"};